import { useNavigationContext } from '../../contexts/navigation-context';
import type { SiteNavigationSlices } from './navigation/site-navigation-types';

export type {
    SiteNavigationPrimary,
    SiteNavigationPrimaryField,
    SiteNavigationPrimaryLevel,
    SiteNavigationPrimarySublevel,
    SiteNavigationSecondary,
    SiteNavigationSlices,
} from './navigation/site-navigation-types';

/**
 * Resolved site navigation (national static menu or microsite newMenu with locationName replacements).
 * Source: NavigationProvider / navigation-context.
 */
const useSiteNavigation = (): SiteNavigationSlices | null => {
    const { siteNavigation } = useNavigationContext();
    return siteNavigation;
};

export default useSiteNavigation;
